<template lang="html">
	<div class="upload_wrap">
		<div class="avatar_kuang el-upload-list--picture-card">
			<div class="avatar_li" v-for="(item,index) in list" :key="index">
				<el-image :src="item" class="image" :preview-src-list="list_list"></el-image>
				<span class="el-upload-list__item-actions">
					<span class="el-upload-list__item-delete" @click="click_del(item,index)"><i class="el-icon-delete"></i></span>
				</span>
			</div>
			<el-upload class="avatar_li" action="" multiple :show-file-list="false" :http-request="fnUploadRequest" :before-upload="before_upload">
				<i class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
		</div>
	</div>
</template>
<script>
import { uploadOSS,deleteOSS } from '@/utils/oss';
export default {
	name: 'upload_image',
	data() {
		return {
			loading:null,
			list:[],
			list_list:[],
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: Array,
			default:()=>[]
		},
		file_name: {
			type: String,
			default: 'image' //file video
		}
	},
	watch: {
		'value': {
		    immediate: true,
		    handler:function(v){
				this.list=v;
				var list_list=[];
				for(var i = 0, length1 = v.length; i < length1; i++){
					list_list[i]=this.api_img_url+v[i].filename;
				}
				this.list_list=list_list
		    }
		},
	},
	methods: {
		async fnUploadRequest(options){
			try {
				let file = options.file;
				let res = await uploadOSS(this.file_name+'/'+file.name,file);
				var list = this.list;
				list.push(res);
	            this.$emit('callback', list);
				this.$message.success("上传成功！");
				this.loading.close();
			} catch (e) {
				this.$message.error('上传失败！');
				this.loading.close();
			}
		},
		before_upload(){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		click_del(data,index){
        	this.removeByIndex(this.list,index);
			this.$emit('callback',this.list);

		}
	}
}
</script>
<style lang="css">

.avatar_kuang .avatar_li .el-upload-list__item-actions{
	width: 40%;
	height: 40%;
}
.avatar_kuang .avatar_li .el-upload-list__item-actions .el-upload-list__item-delete{
	color: #fff!important;
}
.avatar_kuang{
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}
.avatar_kuang .avatar_li{
	margin-bottom: 10px;
	margin-right: 10px;
	position: relative;
	display: inline-block
}
.avatar_kuang .avatar_li .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	display: block;
	width: 100px;
	height: 100px;
	line-height: 100px!important;
	font-size: 28px;
	color: #8c939d;
	text-align: center;
}
.avatar_kuang .avatar_li .el-upload .el-upload-dragger{
	width: 100%;
	height: 100%;
}
.avatar_kuang .avatar_li .el-upload:hover {
	border-color: #409EFF;
}
.avatar_kuang .avatar_li .el-upload .avatar{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.avatar_kuang .avatar_li .image{
	border: 1px dashed #d9d9d9;
	width: 100px;
	height: 100px;
	object-fit: contain;
	display: block;
}
.avatar_kuang .avatar_li .image img{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.avatar_kuang .avatar_li .avatar-uploader-icon {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/uploads.vue